import { bizExternalCustomerTable } from "data/tables/use-preferred-name.js";
import * as React from 'react';
export default {
  bizExternalCustomerTable,
  React
};